import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { TableRow, TableHead, Button } from '@mui/material';
import { TableCellWithWidth } from 'components/list/TableComponentsStyled';
import AddIcon from '@mui/icons-material/Add';

const FinancialProductSeasonalityTemplatesTableHead = ({ canWrite, onAdd, isSaved, lockControls }) => {
  const { t } = useTranslation();

  return (
    <TableHead>
      <TableRow>
        <TableCellWithWidth style={{ fontWeight: 'bold' }} w={50}>{t('FinancialProduct.Details.SeasonalityTemplates.SeasonalityTemplate')}</TableCellWithWidth>
        <TableCellWithWidth style={{ fontWeight: 'bold' }} w={20}>{t('FinancialProduct.Details.SeasonalityTemplates.Default')}</TableCellWithWidth>
        <TableCellWithWidth w={30} align='right'>
          <Button color='primary' variant='contained' startIcon={<AddIcon />} disabled={!isSaved || !canWrite || lockControls} onClick={onAdd}>
            {t('FinancialProduct.Details.SeasonalityTemplates.Add')}
          </Button>
        </TableCellWithWidth>
      </TableRow>
    </TableHead>
  );
};

FinancialProductSeasonalityTemplatesTableHead.propTypes = {
  canWrite: PropTypes.bool.isRequired,
  onAdd: PropTypes.func.isRequired,
  isSaved: PropTypes.bool.isRequired,
  lockControls: PropTypes.bool.isRequired
};

export default FinancialProductSeasonalityTemplatesTableHead;
